import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { type RootState } from "../../app/store";
import { type ISceneState } from "./sceneInterface";

const initialState: ISceneState = {
  Scenes: {}
};

export const sceneSlice = createSlice({
  name: "scene",
  initialState,
  reducers: {
    hasHotelConfiguration: (state, action: PayloadAction<boolean>) => {
      if (action.payload) {
        state.Scenes = {Calendar: "unlocked"};
      }
    },
  },
});

export const { hasHotelConfiguration } = sceneSlice.actions;

// Selectors
export const selectScenes = (state: RootState) => state.scene;


export default sceneSlice.reducer;
